// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__Adf7N","notFoundLink":"NotFound_notFoundLink__0C3+S"};